export function registerServiceWorker({ isProd = import.meta.env.PROD, nav = globalThis.navigator } = {}) {
  if (!isProd || !nav?.serviceWorker) return false;
  window.addEventListener('load', () => {
    nav.serviceWorker.register('/sw.js').catch(() => {});
  });
  return true;
}
